import { Injectable } from '@angular/core';
import { TelephonyQueryParamsService } from 'src/app/services/telephony/telephony-queryparams.service';
import { InterviewDefaultDataProviderService } from '../../shared/interview-new/instances/data-providers/interview-default-data-provider.service';

export const interviewAddmemberDataProviderToken = 'interview-addmember-data-provider';

@Injectable()
export class InterviewAddMemberDataProviderService extends InterviewDefaultDataProviderService {

    static AddMemberConfigName = 'ADDMEMBER_INTERVIEW';

    constructor(private telephonyParamsService: TelephonyQueryParamsService){
        super();
    }

    generateContextData(contextData?: any, input?: any) {
        const queryParams = this.telephonyParamsService.queryParamsSync;

        return {
            ...super.generateContextData(contextData, input),
            skillname: queryParams.skillName,
            contactid: queryParams.contactId,
            direction: queryParams.direction
        };
    }
}


